export function getReviewOutcomeLabels(t) {
  return {
    pending: t("deletionCaseUi.outcomePending"),
    deleted: t("deletionCaseUi.outcomeDeleted"),
    not_deleted: t("deletionCaseUi.outcomeNotDeleted"),
  };
}

export function getReviewOutcomeOptions(t) {
  const labels = getReviewOutcomeLabels(t);
  return [
    { value: "pending", label: labels.pending },
    { value: "deleted", label: labels.deleted },
    { value: "not_deleted", label: labels.not_deleted },
  ];
}

export function formatOutcomeSummaryShortI18n(t, summary) {
  if (!summary || summary.total === 0) return "—";
  const parts = [];
  if (summary.deleted > 0) {
    parts.push(t("deletionCaseUi.deletedCount", { count: summary.deleted }));
  }
  if (summary.notDeleted > 0) {
    parts.push(t("deletionCaseUi.notDeletedCount", { count: summary.notDeleted }));
  }
  if (summary.pending > 0) {
    parts.push(t("deletionCaseUi.pendingCount", { count: summary.pending }));
  }
  return parts.join(" · ") || "—";
}
